import React, { useState } from "react";
import "./ContactMain.css";

export default function ContactMain({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    label: "LET'S START TALKING",
    title: "REACH OUT TO US",
    subtitle: "Porta elementum a enim euismod quam justo lectus. Dis parturient montes nascetur ridiculus mus donec rhoncus.",
    formTitle: "BOOK YOUR FREE CONSULTATION",
    infoCards: [
      {
        icon: "/assets/images/Contact/location.png",
        title: "Company Address",
        text: "Ouagadougou, BurkinaFaso : Aux 1200 logements; avenue Jean Baptiste KIENDREBEOGO.",
        highlight: false,
      },
      {
        icon: "/assets/images/Contact/phone.png",
        title: "Call Us",
        text: "+226 70 19 20 68",
        highlight: true,
      },
      {
        icon: "/assets/images/Contact/email.png",
        title: "Email",
        text: "info@pestelandpartners.com",
        highlight: false,
      },
      {
        icon: "/assets/images/Contact/time.png",
        title: "Office Hours",
        text: (
          <>
            Mon to Sat | 9:30 AM – 6:30 PM <br />
            Sunday : Closed
          </>
        ),
        highlight: false,
      },
    ],
    serviceOptions: [
      "Asset Management",
      "Banking",
      "Financial Advisory Services",
      "Financial Service Tax",
      "Fintech",
      "Insurance",
    ],
    placeholders: {
      firstName: "First Name*",
      lastName: "Last Name*",
      email: "Email Address*",
      phone: "Phone Number*",
      company: "Company*",
      services: "Choose Services",
      message: "Additional Message",
    },
    button: {
      submit: "Get In Touch",
      submitting: "Submitting...",
    },
    messages: {
      success: "Enquiry submitted successfully!",
      error: "Something went wrong!",
      networkError: "Network error!",
    },
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    label: "COMMENÇONS À PARLER",
    title: "CONTACTEZ-NOUS",
    subtitle: "Porta elementum a enim euismod quam justo lectus. Dis parturient montes nascetur ridiculus mus donec rhoncus.",
    formTitle: "RÉSERVEZ VOTRE CONSULTATION GRATUITE",
    infoCards: [
      {
        icon: "/assets/images/Contact/location.png",
        title: "Adresse de l'entreprise",
        text: "Ouagadougou, Burkina Faso : Aux 1200 logements, avenue Jean-Baptiste Kiendrebeogo.",
        highlight: false,
      },
      {
        icon: "/assets/images/Contact/phone.png",
        title: "Appelez-nous",
        text: "+226 70 19 20 68",
        highlight: true,
      },
      {
        icon: "/assets/images/Contact/email.png",
        title: "Email",
        text: "info@pestelandpartners.com",
        highlight: false,
      },
      {
        icon: "/assets/images/Contact/time.png",
        title: "Heures d'ouverture",
        text: (
          <>
            Lun au Sam | 9h30 – 18h30 <br />
            Dimanche : Fermé
          </>
        ),
        highlight: false,
      },
    ],
    serviceOptions: [
      "Gestion d'actifs",
      "Services bancaires",
      "Services de conseil financier",
      "Fiscalité des services financiers",
      "Fintech",
      "Assurance",
    ],
    placeholders: {
      firstName: "Prénom*",
      lastName: "Nom*",
      email: "Adresse e-mail*",
      phone: "Numéro de téléphone*",
      company: "Entreprise*",
      services: "Choisir les services",
      message: "Message supplémentaire",
    },
    button: {
      submit: "Nous contacter",
      submitting: "Envoi en cours...",
    },
    messages: {
      success: "Demande soumise avec succès !",
      error: "Quelque chose s'est mal passé !",
      networkError: "Erreur réseau !",
    },
  };

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;
  const { label, title, subtitle, formTitle, infoCards, serviceOptions, placeholders, button, messages } = data;

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    services: "",
    message: "",
    number: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const res = await fetch(
        "https://admin.pestelandpartners.com/api/PnpAPI/AddEnquiry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await res.json();

      if (res.ok) {
        setSuccessMsg(messages.success);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          company: "",
          services: "",
          message: "",
          number: "",
        });
      } else {
        setErrorMsg(data.message || messages.error);
      }
    } catch (err) {
      setErrorMsg(messages.networkError);
    }

    setLoading(false);
  };

  return (
    <div className="container contactmain-wrapper">
      {/* LEFT SIDE */}
      <div className="row">
        <div className="col-lg-6">
          <div className="contact-label">
            <img src="/assets/images/contact/Frame1.png" alt="icon" /> {label}
          </div>

          <h2 className="contact-title">{title}</h2>

          <p className="contact-subtitle">{subtitle}</p>

          {/* Info Cards */}
          <div className="row mt-4">
            {infoCards.map((item, idx) => (
              <div className="col-md-6 mb-3" key={idx}>
                <div
                  className={`contact-card ${
                    item.highlight ? "highlight" : ""
                  }`}
                >
                  <div className="contact-icon">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <div className="icon-width">
                    <h5 className="contact-card-title">{item.title}</h5>
                    <p className="contact-card-text">{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE — FORM */}
        <div className="col-lg-6 mt-4 mt-lg-0">
          <div className="contact-form-card">
            <h3 className="form-title">{formTitle}</h3>
            {successMsg && <p className="success-msg">{successMsg}</p>}
            {errorMsg && <p className="error-msg">{errorMsg}</p>}
            <form onSubmit={handleSubmit}>
              <div className="row mt-3">
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    placeholder={placeholders.firstName}
                    className="form-input"
                    value={formData.firstName}
                    onChange={(e) =>
                      setFormData({ ...formData, firstName: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    placeholder={placeholders.lastName}
                    className="form-input"
                    value={formData.lastName}
                    onChange={(e) =>
                      setFormData({ ...formData, lastName: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <input
                    type="email"
                    placeholder={placeholders.email}
                    className="form-input"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    placeholder={placeholders.phone}
                    className="form-input"
                    value={formData.number}
                    onChange={(e) =>
                      setFormData({ ...formData, number: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    placeholder={placeholders.company}
                    className="form-input"
                    value={formData.company}
                    onChange={(e) =>
                      setFormData({ ...formData, company: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <select
                    className="form-input"
                    value={formData.services}
                    onChange={(e) =>
                      setFormData({ ...formData, services: e.target.value })
                    }
                    required
                  >
                    <option value="">{placeholders.services}</option>
                    {serviceOptions.map((service, i) => (
                      <option key={i} value={service}>
                        {service}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-12 mb-3">
                  <textarea
                    placeholder={placeholders.message}
                    className="form-textarea"
                    rows="4"
                    value={formData.message}
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                  ></textarea>
                </div>
              </div>

              <button className="form-btn" disabled={loading}>
                {loading ? button.submitting : button.submit}{" "}
                {!loading && (
                  <img src="/assets/images/Career/arrowwhite.png" width={15} alt="arrow" />
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}